/* eslint-disable jsx-a11y/anchor-is-valid */
import ArticleItem from "component/landing-page/article-item/ArticleItem";
import ShowMoreAndLess from "modules/product/showMoreAndLess/ShowMoreAndLessContainer";
import { ArticleObject } from "../../component/landing-page/interfaces/ArticleData";

function OverViewTab(props: any) {
  const { items } = props;
  const articles = items.filter((item: ArticleObject) => item.type === "article");
  return (
    <ShowMoreAndLess
      contentDescription={(
        articles.map((articleObj: ArticleObject, index: number) => (
          <ArticleItem
            key={articleObj.article?.title + index}
            title={articleObj.article?.title}
            imagesUrlV2={articleObj.article?.imagesUrlV2}
            imagesUrl={articleObj.article?.imagesUrl}
            content={articleObj.article.content}
            imgSrc={`${process.env.NEXT_PUBLIC_CMS}/`}
            leftRightImages={articleObj.article.leftRightImages}
            layout={articleObj.article.layout}
          />
        ))
      )}
    />

  );
}

export default OverViewTab;
